import {
  DvTextCellEditor,
  DvToolbarAction,
  DvToolbarActionEvent,
} from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { AttachmentsService } from '@shared/services/attachments.service';
import { ColDef } from 'ag-grid-community';
import { take, tap } from 'rxjs';
import { DamageReportAttachmentDto } from './interfaces';

@Injectable()
export class DamageReportAttachmentsGridService {
  private attachmentsService = inject(AttachmentsService);

  getColumnDefs(
    isEditRestricted: () => boolean
  ): ColDef<DamageReportAttachmentDto>[] {
    return [
      {
        colId: 'DocumentID',
        headerName: 'Grid.Id',
        type: [ColumnType.Id],
        field: 'DocumentID',
        hide: true,
      },
      {
        headerName: 'PictureDocumentGrid.DocumentThumbnail',
        field: 'DocumentThumbnail',
        type: [ColumnType.Thumbnail],
        enableRowGroup: false,
        width: 100,
        flex: 4,
      },
      {
        headerName: 'PictureDocumentGrid.DocumentDescription',
        field: 'DocumentDescription',
        type: [ColumnType.Text],
        cellEditor: DvTextCellEditor,
        editable: () => !isEditRestricted(),
      },
      {
        field: 'CreatedTime',
        headerName: 'PictureDocumentGrid.CreatedTime',
        type: [ColumnType.DateTime],
      },
      {
        headerName: 'PictureDocumentGrid.DocumentFileName',
        field: 'FileName',
        type: [ColumnType.Text],
        flex: 4,
      },
    ];
  }

  getToolbarActions(
    uploadFileFn: () => void,
    deleteFileFn: (event?: DvToolbarActionEvent) => void
  ): DvToolbarAction[] {
    return [
      ...getStandardActionPreset(),
      {},
      {
        icon: 'download',
        tooltipKey: 'Grid.Download',
        disabled: true,
        clickFn: ({ api }) => {
          this.attachmentsService
            .getAttachmentUrl(api.getSelectedNodes()[0].data.DocumentID, false)
            .pipe(
              take(1),
              tap(url => this.attachmentsService.downloadAttachment(url))
            )
            .subscribe();
        },
      },
      {
        icon: 'delete',
        clickFn: (event: DvToolbarActionEvent) => deleteFileFn(event),
        disabled: true,
        tooltipKey: 'Grid.Delete',
      },
      {
        icon: 'add_box',
        clickFn: uploadFileFn,
        disabled: false,
        tooltipKey: 'Grid.Add',
      },
    ];
  }
}
